<template>
  <div id="app" class="App">
    <router-view></router-view>
  </div>
</template>

<script type="text/babel">
  export default {
    name: 'app'
  }
</script>

<style scoped>
  .App {
    height: 100%;
    
  }

  .CoverAllWindow {
    width: 100%;
    height: 100%;
    position: absolute;
  }
</style>

<style>
  @font-face {
    font-family: 'AzoSans-Light';
    src: url('./fonts/AzoSans-Light.woff') format("woff"); 
  }

  @font-face {
    font-family: 'AzoSans-Bold';
    src: url('./fonts/AzoSans-Bold.woff') format("woff"); 
  }

  @font-face{
    font-family: 'Open Sans';
    src: url('./fonts/OpenSans-Regular.ttf') format("truetype")
  }

  body, html {
    font-family: 'AzoSans-Light';
    overflow: hidden;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    user-select: none;
  }

  .selectable { 
    user-select: text !important
  }

  textarea[data-fabric-hiddentextarea] {
    top: 1px !important;
    left: 1px !important;
  }

   input[type="checkbox"] {
    display: none
  }

  input[type="checkbox"] + label
  {
    display:inline-block;
    line-height: 2.3;
    font-size: 13.333px;
    position: relative;
    padding: 0 0 0 1.5rem;
    min-height: 1.8rem;
    cursor: pointer
  }

  input[type="checkbox"] + label:before {
    content:"";
    height: 1rem;
    width: 1rem;
    position: absolute;
    left: 0rem;
    top: 5px;
    background-repeat: no-repeat;
  }

  input[type="checkbox"]:checked + label:after {
    height: 9px;
    width: 4px;
    content: '';
    position: absolute;
    left: 6px;
    transform: rotate(45deg);
    top: 7px;
    border-bottom: 2px solid #5650d7;
    border-right: 2px solid #5650d7;
  }

  input[type="checkbox"][disabled] + label:before { opacity: 0.5 }

  input[type="checkbox"][disabled] + label { color: rgba(0,0,0,0.3) }

  input[type="checkbox"]:checked + label:before {
    background: #eee;
  }

  input[type="checkbox"] + label:before {
    background: #eee;
    border-radius: 5px;
    border: 1px #eee solid;
  }
</style>
